"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var auditDoctor = [{
        path: '/audit-doctor',
        meta: {
            title: "医生审核"
        },
        component: function () { return Promise.resolve().then(function () { return require("@/views/audit-doctor/list.vue"); }); }
    }];
exports.default = auditDoctor;
